export default __webpack_public_path__ + "static/media/youtube.09304c78.svg";